import { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Sidebar from "./views/global/Sidebar";
import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, tokens, useMode } from "./theme";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dashboard from "./views/dashboard/Dashboard";
import RoutineManagement from "./views/routine/RoutineManagement";
import ExerciseManagement from "./views/excercise/ExerciseManagement";
import UserSessionModal from "./components/Global/UserSessionModal/UserSessionModal";


function App() {
  const [theme, colorMode] = useMode();
  const colors = tokens(theme.palette.mode);
  const [isSidebar, setIsSidebar] = useState(true);
  const [showUserModal, setShowUserModal] = useState(false);
  const sidebarWidth = "250px";

  useEffect(() => {
    const currentUser = localStorage.getItem("currentUser");
    if (!currentUser) {
      setShowUserModal(true);
    }
  }, []);

  const handleUserSelection = (userName) => {
    setShowUserModal(false);
  };

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <UserSessionModal open={showUserModal} onSelectUser={handleUserSelection} />
        <div className="app" style={{ display: "flex", minHeight: "100vh" }}>
          {isSidebar && (
            <Box
              className="sidebar"
              sx={{
                position: "fixed",
                top: 0,
                left: 0,
                height: "100vh",
                width: sidebarWidth,
                transition: "width 0.3s",
                zIndex: 1000,
                display: { xs: "none", md: "flex" },
              }}
            >
              <Sidebar />
            </Box>
          )}
          <Box
            className="content"
            sx={{
              marginLeft: isSidebar ? { xs: "0px", md: sidebarWidth } : "0px",
              flexGrow: 1,
              width: isSidebar ? "80%" : "100%",
              transition: "margin-left 0.3s",
            }}
          >
            <div className="main-content">
              <ToastContainer />
              <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/routines/:day" element={<RoutineManagement />} />
                  <Route path="/routines/:day/:exerciseId" element={<ExerciseManagement />} />
              </Routes>
            </div>
          </Box>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
